import { IRestfulConfigMap } from "@core/data-access/restful";
import { envConfig } from "@env/env-config";
let DesignMethodRestConfig: IRestfulConfigMap = {
    "designMethodRestService": {
        appPath: envConfig.appPath("base"),
        isAuth: true,
        actions: {
            calculateDesignMethod: {
                method: "POST",
                path: "api/products/:productId/designMethod",
                paramDefaults: {
                    productId: "@productId",
                    profileId:"@profileId",
                    versionedAttributeId:"@versionedAttributeId"
                }
            },
            getByFormId: {
                method: "GET",
                path: "api/products/:productId/forms/:formId/designMethod",
                paramDefaults: {
                    productId: "@productId",
                    formId: "@formId"
                }
            }
        }
    }
}
export { DesignMethodRestConfig };